import { render, staticRenderFns } from "./userSeriesVoList.vue?vue&type=template&id=5d7180dd&scoped=true&"
import script from "./userSeriesVoList.vue?vue&type=script&lang=js&"
export * from "./userSeriesVoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7180dd",
  null
  
)

export default component.exports